import { PublicNav, PublicFooter } from "@/components/app/PublicNav";
import { Award, BookOpen, Building2, GraduationCap, Leaf, Sparkles } from "lucide-react";

export default function About() {
  return (
    <div className="min-h-screen bg-slate-50">
      <PublicNav />
      <section className="max-w-4xl mx-auto px-6 py-16">
        <span className="gc-label">Tentang Inovasi</span>
        <h1 className="gc-h1 mt-3">Sistem Informasi Akuntansi untuk Beton Rendah Karbon.</h1>
        <div className="mt-4 inline-flex items-center gap-2 rounded-full bg-emerald-50 border border-emerald-100 px-3 py-1 text-xs font-semibold text-emerald-700">
          <GraduationCap className="w-3.5 h-3.5" /> Produk Inovasi Politeknik Negeri Manado
        </div>
        <p className="mt-5 text-slate-600 leading-relaxed">GREENCON HPP adalah <strong>sistem informasi akuntansi berbasis web</strong> yang dikembangkan dari hasil penelitian <strong>Politeknik Negeri Manado</strong>. Sistem ini menyatukan perhitungan Harga Pokok Produksi (HPP) dengan pendekatan <em>full costing</em> dan integrasi <em>green accounting</em>, serta dihilirisasikan kepada industri konstruksi melalui kegiatan pengabdian kepada masyarakat.</p>

        <div className="mt-10 grid md:grid-cols-2 gap-5">
          <div className="gc-card">
            <BookOpen className="text-emerald-600 w-6 h-6" />
            <h3 className="gc-h3 mt-3">Latar Belakang</h3>
            <p className="text-sm text-slate-600 mt-2">Perhitungan HPP pada industri produsen beton umumnya masih dilakukan secara manual sehingga rawan tidak akurat. Biaya lingkungan belum diidentifikasi secara sistematis, dan penentuan harga jual belum sepenuhnya berbasis HPP.</p>
          </div>
          <div className="gc-card">
            <Sparkles className="text-emerald-600 w-6 h-6" />
            <h3 className="gc-h3 mt-3">Tujuan Pengembangan</h3>
            <p className="text-sm text-slate-600 mt-2">Menyediakan sistem yang sederhana, aman, multi-tenant, dan mampu menghitung HPP secara transparan — dari data bahan baku, tenaga kerja, overhead, hingga biaya lingkungan.</p>
          </div>
          <div className="gc-card">
            <Leaf className="text-emerald-600 w-6 h-6" />
            <h3 className="gc-h3 mt-3">Full Costing + Green Accounting</h3>
            <p className="text-sm text-slate-600 mt-2">Sistem menggabungkan seluruh komponen biaya produksi. Biaya lingkungan dibedakan antara yang dibebankan ke HPP dan yang hanya untuk pelaporan, mencegah <em>double counting</em>.</p>
          </div>
          <div className="gc-card">
            <Award className="text-emerald-600 w-6 h-6" />
            <h3 className="gc-h3 mt-3">Publikasi & Diseminasi</h3>
            <p className="text-sm text-slate-600 mt-2">Sistem dikembangkan dari hasil penelitian dan didiseminasikan pada industri konstruksi. Publikasi ilmiah, HKI, dan paten dikelola oleh Politeknik Negeri Manado.</p>
          </div>
        </div>

        <div className="mt-12 rounded-3xl bg-[#0B192C] p-8 text-white">
          <div className="flex items-center gap-3">
            <GraduationCap className="w-7 h-7 text-emerald-300" />
            <div>
              <div className="text-xs uppercase tracking-widest text-emerald-300">Pengembang & Pemilik Sistem</div>
              <div className="font-cabinet text-2xl font-bold">Politeknik Negeri Manado</div>
            </div>
          </div>
          <p className="mt-4 text-slate-300 leading-relaxed text-sm">GREENCON HPP dikembangkan, dikelola, dan dievaluasi oleh tim peneliti dan pengabdian Politeknik Negeri Manado. Aplikasi ini digunakan oleh industri konstruksi sebagai <em>pengguna</em> — data operasional mereka tetap menjadi tanggung jawab masing-masing perusahaan, sedangkan hak kekayaan intelektual sistem ini tetap pada Politeknik Negeri Manado.</p>
          <div className="mt-5 flex items-center gap-2 text-xs text-slate-400">
            <Building2 className="w-4 h-4" /> Diseminasi kepada industri konstruksi & produsen beton
          </div>
        </div>
      </section>
      <PublicFooter />
    </div>
  );
}
